import React, { useState, useEffect } from "react";

function Cookie() {
  const [show, setShow] = useState(false);
  const [visible, setVisible] = useState(true);
  const [analyticsEnabled, setAnalyticsEnabled] = useState(true);
  const [marketingEnabled, setMarketingEnabled] = useState(true);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(!show);

  function setCookie(name, value, days) {
    var expires = "";
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie =
      name + "=" + (value || "") + expires + "; path=/ ; sameSite=Lax";
  }

  const saveSelection = () => {
    if (analyticsEnabled && marketingEnabled) {
      setCookie("cookie_privacy_policy", "true", 366);
      if (typeof window.acceptCookies === "function") {
        window.acceptCookies();
      }
    } else if (!analyticsEnabled && !marketingEnabled) {
      // Full decline
      setCookie("cookie_privacy_policy", "false", 366);
      setCookie("_ga", "", -1);
      if (typeof window.declineCookies === "function") {
        window.declineCookies();
      }
    } else {
      // Partial acceptance - essential + selected services
      setCookie("cookie_privacy_policy", "partial", 366);
      if (typeof window.acceptPartialCookies === "function") {
        window.acceptPartialCookies(analyticsEnabled, marketingEnabled);
      }
    }
    setVisible(false);
    handleClose();
  };

  function getCookie(name) {
    const row = document.cookie
      .split("; ")
      .find((item) => item.startsWith(name + "="));
    return row ? decodeURIComponent(row.split("=")[1]) : undefined;
  }

  useEffect(() => {
    // Restore previous consent and hide banner if already decided
    try {
      const savedConsent =
        window.localStorage && window.localStorage.getItem("cookiesAccepted");
      if (
        savedConsent === "true" ||
        savedConsent === "partial" ||
        savedConsent === "false"
      ) {
        setVisible(false);
        return;
      }
    } catch (_) {}

    const cookieConsent = getCookie("cookie_privacy_policy");
    if (
      cookieConsent === "true" ||
      cookieConsent === "partial" ||
      cookieConsent === "false"
    ) {
      setVisible(false);
    }
  }, []);

  const handlePrimaryAction = () => {
    if (!show) {
      // Accept all when collapsed
      setCookie("cookie_privacy_policy", "true", 366);
      if (typeof window.acceptCookies === "function") {
        window.acceptCookies();
      }
      setVisible(false);
    } else {
      // Save current toggle selection
      saveSelection();
    }
  };

  return (
    <>
      {!visible ? null : (
        <div className="CookieConsent">
          <div className="CookieConsent_body overflow-auto">
            <h3 className="fw-normal mb-3 tt-normal">Cookies</h3>
            <p className="layout_mb__30">
              Wir verwenden Cookies, um unsere Website bereitzustellen und zu
              optimieren. Indem Sie auf „Alle akzeptieren“ klicken, stimmen Sie
              der Verwendung zu. In den Einstellungen können Sie Ihre Auswahl
              anpassen.
            </p>
            <div
              className={`cookie-settings-collapse ${show ? "show" : ""}`}
              style={{
                maxHeight: show ? "2000px" : "0",
                overflow: show ? "visible" : "hidden",
                transition:
                  "max-height 0.4s ease-in-out, opacity 0.3s ease-in-out",
                opacity: show ? 1 : 0,
              }}
            >
              {/* ERFORDERLICH - Always Active */}
              <div className="mb-4">
                <h5 className="fw-bold mb-2 d-flex justify-content-between">
                  ERFORDERLICH{" "}
                  <span className="text-muted fw-normal">Immer aktiv</span>
                </h5>
                <p className="mb-2">
                  Erforderlich für den Betrieb der Website (z. B. Sicherheit,
                  Seitennavigation, gespeicherte Einstellungen). Diese Cookies
                  können nicht deaktiviert werden.
                </p>
              </div>

              {/* ANALYTIK - Checkbox */}
              <div className="mb-4 pb-3 border-bottom">
                <div className="d-flex align-items-start mb-2">
                  <div className="flex-grow-1">
                    <div className="special-checkbox">
                      <input
                        type="checkbox"
                        id="analyticsCheckbox"
                        className="form-check-input me-3 mt-1"
                        checked={analyticsEnabled}
                        onChange={(e) => setAnalyticsEnabled(e.target.checked)}
                      />
                      <label
                        htmlFor="analyticsCheckbox"
                        className="form-check-label fw-bold mb-2"
                      >
                        ANALYTIK
                      </label>
                    </div>
                    <p className="mb-2">
                      Hilft uns zu verstehen, wie die Website genutzt wird, um
                      Inhalte und Leistung zu verbessern. Wir verwenden dafür{" "}
                      <a
                        href="https://support.google.com/analytics/answer/6004245"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Google Analytics
                      </a>
                      .
                    </p>
                  </div>
                </div>
              </div>

              {/* MARKETING - Checkbox */}
              <div className="pb-3">
                <div className="d-flex align-items-start mb-2">
                  <div className="flex-grow-1">
                    <div className="special-checkbox">
                      <input
                        type="checkbox"
                        id="marketingCheckbox"
                        className="form-check-input me-3 mt-1"
                        checked={marketingEnabled}
                        onChange={(e) => setMarketingEnabled(e.target.checked)}
                      />
                      <label
                        htmlFor="marketingCheckbox"
                        className="form-check-label fw-bold mb-2"
                      >
                        MARKETING
                      </label>
                    </div>
                    <p className="mb-2">
                      Ermöglicht personalisierte Werbung, Conversion-Messung und
                      Remarketing. Wir verwenden dafür{" "}
                      <a
                        href="https://business.safety.google/adscookies/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Google Ads
                      </a>
                      .
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="CookieConsent__footer d-grid pt-3">
            <div className="d-grid d-md-flex mb-3 gap-3 gap-md-3">
              <button
                className="btn btn__small btn__fill btn__fill_solid flex-grow-1"
                onClick={handleShow}
              >
                EINSTELLUNGEN {show ? "SCHLIESSEN" : "ÖFFNEN"}
              </button>
              <button
                className="btn btn__small btn__fill btn__fill_solid btn__fill_solid_primary position-relative flex-grow-1"
                onClick={handlePrimaryAction}
              >
                {show ? "AUSWAHL SPEICHERN" : "ALLE AKZEPTIEREN"}
              </button>
            </div>
            <div className="d-flex gap-4 justify-content-start">
              <a href="/datenschutz" className="text-decoration-none">
                Datenschutz
              </a>
              <a href="/impressum" className="text-decoration-none">
                Impressum
              </a>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Cookie;
